import { useState } from 'react'
import { Palette } from 'lucide-react'
import { cn } from '../../lib/shadcn/utils'
import { useCapabilities } from '../../hooks/useCapabilities'
import { DesignRequestDialog } from './DesignRequestDialog'

/**
 * Ask for a design, from wherever you happen to be standing.
 *
 * IT LIVES IN THE SIDEBAR ON PURPOSE, and that is the whole design decision in
 * this file. What this replaces is a WhatsApp message: someone is looking at a
 * driver's record, or a vehicle, or nothing at all, and needs a poster. A form
 * that requires opening the Marketing tab first loses to WhatsApp every single
 * time, and then the request has no record, no date and no brief.
 *
 * Gated on canView, the same gate the request itself uses. Asking for a poster
 * is not a marketing privilege: Luyanda asked for it to be available to
 * "me or Xolile or any other person of the team", and a queue only one
 * department can write to is a queue nobody uses.
 */
export function RequestDesignButton({ compact = false }: { compact?: boolean }) {
  const { canView } = useCapabilities()
  const [open, setOpen] = useState(false)

  if (!canView) return null

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title={compact ? 'Ask for a design' : undefined}
        aria-label="Ask for a design"
        className={cn(
          'flex w-full items-center gap-3 rounded-md border border-dashed border-[hsl(var(--brand))]/50 px-3 py-2.5 text-sm font-medium text-[hsl(var(--brand))] transition-colors hover:bg-[hsl(var(--brand-soft))] sm:py-2',
          compact && 'justify-center px-2',
        )}
      >
        <Palette className="h-4 w-4 shrink-0" />
        {!compact && 'Ask for a design'}
      </button>
      <DesignRequestDialog open={open} onOpenChange={setOpen} />
    </>
  )
}
